export const INVOICE_PAYERS_GET_REQUESTED = 'INVOICE_PAYER_GET_REQUESTED';
export const INVOICE_PAYERS_GET_SUCCEED = 'INVOICE_PAYER_GET_SUCCEED';
export const INVOICE_PAYERS_GET_FAILED = 'INVOICE_PAYER_GET_FAILED';
